// Tab a "pillola" riusabili — lo stile canonico per tab e filtri in-page
// (introdotto con l'editor attività, 2026-07-17): attiva = verde brand pieno,
// inattive = bordo neutro con hover verde. L'allineamento lo decide il wrapper
// via `className`. La navigazione di primo livello della dashboard admin
// (bottoni squadrati con icona: Statistiche/Attività/...) resta volutamente
// uno stile diverso: è un menu tra pagine, non una tab dentro la pagina.
const TabPills = ({ tabs, activeKey, onChange, className = '' }) => (
    <div className={`flex flex-wrap gap-2 ${className}`}>
        {
            tabs.map(tab => (
                <button
                    key={tab.key}
                    className={`py-2 px-4 rounded-full border-2 text-sm transition-colors ${activeKey === tab.key ? 'border-[#225424] bg-[#225424] text-white' : 'border-neutral-300 bg-white text-neutral-600 hover:border-[#225424]'}`}
                    onClick={() => onChange(tab.key)}
                >
                    {tab.label}
                </button>
            ))
        }
    </div>
);

export default TabPills;
